var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragZoneImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_179053",
    "data-name": "Group 179053",
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 44,
    viewBox: "0 0 228 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6749",
    "data-name": "Rectangle 6749",
    fill: "#f2f6fa",
    stroke: "#203662",
    strokeWidth: 1,
    strokeDasharray: "4 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 44,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 227,
    height: 43,
    rx: 5.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_180240",
    "data-name": "Group 180240",
    transform: "translate(104 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21136",
    "data-name": "Path 21136",
    d: "M18.419,12.838A2.419,2.419,0,1,0,16,10.419a2.419,2.419,0,0,0,2.419,2.419Zm0-3.225a.806.806,0,1,1-.806.806A.806.806,0,0,1,18.419,9.613Z",
    transform: "translate(-4.711 -4.775)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21135",
    "data-name": "Path 21135",
    d: "M3.613,20v1.613h3.7L2,26.923l1.14,1.14,5.311-5.311v3.7h1.613V20Z",
    transform: "translate(-2 -7.098)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21137",
    "data-name": "Path 21137",
    d: "M21.74,4H5.613A1.613,1.613,0,0,0,4,5.613v8.064H5.613V5.613H21.74V17.845L18.845,14.95a1.613,1.613,0,0,0-2.274,0l-1.282,1.282-4.975-4.975L9.173,12.4l2.89,2.89,2.088,2.088a1.613,1.613,0,0,0,2.274,0L17.708,16.1l4.032,4.032V21.74H13.676v1.613H21.74a1.613,1.613,0,0,0,1.613-1.613V5.613A1.613,1.613,0,0,0,21.74,4Z",
    transform: "translate(-2.387 -4)",
    fill: "#203662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragZoneImage);
export default __webpack_public_path__ + "static/media/DragZoneImage.2271079e9460b9e57889141996354299.svg";
export { ForwardRef as ReactComponent };